import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from "@angular/material/dialog";
import {CommonModule} from "@angular/common";
import {ModalWindowComponent} from "../../../std-components/modal-window/modal-window.component";
import {NumberWithSpacesPipe} from "../../../shared/pipes/number-with-spaces.pipe";
import {IPlace} from "../commercial-rooms/commercial-rooms.component";

export interface IPlaceInfoData {
  place: IPlace;
  floorNumber: number;
}

@Component({
  selector: 'app-place-info-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ModalWindowComponent,
    NumberWithSpacesPipe,
    MatDialogClose
  ],
  templateUrl: './place-info-dialog.component.html',
  styleUrl: './place-info-dialog.component.scss'
})
export class PlaceInfoDialogComponent {

  readonly dialogRef = inject(MatDialogRef<PlaceInfoDialogComponent>);
  readonly data = inject<IPlaceInfoData>(MAT_DIALOG_DATA);

  get place(): IPlace {
    return this.data.place;
  }

  isSold(): boolean {
    return !!(this.place.saleDate && this.place.priceAmount);
  }
}
